export function getReturnLink(name: string, zipCode: string): string {
  return `/pages/returns?order_number=${name.replace(
    '#',
    ''
  )}&postcode=${zipCode}`
}
